import { type RouteRecordRaw } from 'vue-router'

import { applyMetaToChildren } from '@/utils/router'

export const seoRouter: RouteRecordRaw[] = [
  {
    children: applyMetaToChildren(
      [
        {
          component: async () => import('../views/RedirectsView.vue'),
          meta: {
            title: 'seo.redirects',
          },
          name: 'seo.redirects',
          path: 'redirects',
        },
        {
          component: async () => import('../views/CuisineCategoriesView.vue'),
          meta: {
            title: 'seo.cuisine-categories',
          },
          name: 'seo.cuisine-categories',
          path: 'cuisine-categories',
        },
        {
          component: async () => import('../views/SEOInfoView.vue'),
          meta: {
            title: 'seo.seo-info',
          },
          name: 'seo.seo-info',
          path: 'seo-info',
        },
        {
          component: async () => import('../views/SEOSettingsView.vue'),
          meta: {
            title: 'seo.seo-settings',
          },
          name: 'seo.seo-settings',
          path: 'seo-settings',
        },
        {
          component: async () => import('../views/ListingsView.vue'),
          meta: {
            title: 'seo.listings',
          },
          name: 'seo.listings',
          path: 'listings',
        },
      ],
      {
        roles: ['pb:super'],
      }
    ),
    component: {
      name: 'SEOView',
      template: '<router-view />',
    },
    path: 'seo',
    redirect: { name: 'seo.redirects' },
  },
]
